/*@flow*/
import type { Node } from 'react';
import React from 'react';
import Range from './Range';
import Item from './Item';

type PropsT = {
  value: any,
  label: React$Node,
  attrs: { name: string },
  min: number,
  max: number,
  onChange: (any) => any,
};

export default function RangeTemplate(locals: PropsT): Node {
  const safeValue = locals.value || {};
  const minValue = safeValue.min || '';
  const maxValue = safeValue.max || '';

  return (
    <Item label={locals.label}>
      <Range
        name={locals.attrs.name}
        min={locals.min}
        max={locals.max}
        minValue={minValue}
        maxValue={maxValue}
        onChange={(v) => {
          locals.onChange(v);
        }}
      />
    </Item>
  );
}
